import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@components/ui/Button';
// import { PageTransition } from '@components/motion/PageTransition';
import { ROUTES } from '@constants/routes';
import { Wrapper, Grid, Glow, Content, ErrorCode, Title, Description, Buttons } from './styles';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Página não encontrada — Teia de Eventos';
  }, []);

  return (
    <>
      <Wrapper>
        <Grid />
        <Glow />
        <Content
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <ErrorCode
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.34, 1.56, 0.64, 1] }}
          >
            404
          </ErrorCode>

          <Title>Página não encontrada</Title>

          <Description>
            A página que você procura não existe ou foi movida. Volte para o início e explore nossos
            eventos.
          </Description>

          <Buttons>
            <Button variant="primary" size="lg" onClick={() => navigate(ROUTES.home)}>
              Voltar ao início
            </Button>
            <Button variant="outline" size="lg" onClick={() => navigate(ROUTES.events)}>
              Ver eventos
            </Button>
          </Buttons>
        </Content>
      </Wrapper>
    </>
  );
};

export default memo(NotFound);
